import React from "react";

const Footer = () => (
  <footer className="bg-light p-3 text-center">
    <div className="logo" />
    <p>
    © APIVIS. All rights reserved <a href="https://www.apivis.com">APIVIS</a>
    </p>
  </footer>
);

export default Footer;
